__webpack_require__.p = "/eg/ar/customer-service/returns-claims/spareparts/";